import React from 'react';

/**
 * EditIconButton - Reusable pencil icon button for edit actions
 * Matches the banner edit button style exactly
 */
function EditIconButton({ onClick, className = '', disabled = false, title = 'Edit', isLoading = false, ...props }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`p-2 bg-white/90 hover:bg-white rounded-full shadow-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      title={title}
      aria-label={title}
      {...props}
    >
      {isLoading ? (
        <svg className="w-4 h-4 text-slate-600 animate-spin" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
      ) : (
        <svg className="w-4 h-4 text-slate-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
        </svg>
      )}
    </button>
  );
}

export default EditIconButton;

